var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 37.387,
    viewBox: "0 0 200 37.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4082",
    "data-name": "Group 4082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4894",
    "data-name": "Path 4894",
    d: "M335.406,56.126a2.88,2.88,0,0,0,2.93-2.825,2.948,2.948,0,0,0-5.9,0,2.89,2.89,0,0,0,2.966,2.825M323.647,42.637h2.332V55.808h4.45V42.637h2.507V38.682h-2.507v-5.9h-4.45v5.9h-2.332Zm-14.832,4.591a4.734,4.734,0,1,1,4.731,4.909,4.73,4.73,0,0,1-4.731-4.909m4.731,9.111a9.112,9.112,0,1,0-9.182-9.111,9.007,9.007,0,0,0,9.182,9.111m-24.685-9.111a4.692,4.692,0,0,1,4.731-4.839,4.641,4.641,0,0,1,4.7,4.839,4.716,4.716,0,1,1-9.427,0m-4.343-4.944V61.636h4.45v-8.3a6.759,6.759,0,0,0,5.65,2.86c4.839,0,8.122-3.92,8.122-8.969S299.493,38.3,294.62,38.3a6.682,6.682,0,0,0-5.863,3.213V38.684h-4.238v3.6Zm-8.793,14.055c4.025,0,6.745-2.472,6.745-5.826s-2.542-4.731-5.227-5.227l-1.66-.318c-1.235-.283-2.224-.636-2.224-1.625,0-.847.812-1.66,2.154-1.66a2.9,2.9,0,0,1,3.038,2.437l.07.035a5.244,5.244,0,0,1,3.672-1.448l.035-.07c-.636-2.437-3-4.521-6.745-4.521s-6.534,2.472-6.534,5.473c0,2.685,1.731,4.343,5.262,5.049l1.7.353c1.235.283,2.119.671,2.119,1.7,0,1.095-.776,1.941-2.367,1.941a3.568,3.568,0,0,1-3.707-3l-.105-.07A5.086,5.086,0,0,1,268.275,51v.07c.636,3.248,3.567,5.262,7.451,5.262m-17.587-13.7h2.332V55.806h4.45V42.635h2.507V38.68h-2.507v-5.9h-4.45v5.9h-2.332Zm-13.878,2.542a4.25,4.25,0,0,1,4.273-3.319,4.2,4.2,0,0,1,4.343,3.319Zm4.556,11.16c3.566,0,6.639-1.553,8.157-4.874v-.105a5.306,5.306,0,0,1-3.637-1.731h-.07a4.455,4.455,0,0,1-4.343,2.9,4.666,4.666,0,0,1-4.8-3.92h12.961c.776-5.791-2.72-10.454-8.51-10.454a8.758,8.758,0,0,0-8.723,9.076,8.86,8.86,0,0,0,8.969,9.111M225.3,45.177a4.25,4.25,0,0,1,4.273-3.319,4.194,4.194,0,0,1,4.343,3.319Zm4.556,11.16c3.566,0,6.639-1.553,8.157-4.874v-.105a5.306,5.306,0,0,1-3.637-1.731h-.07a4.455,4.455,0,0,1-4.343,2.9,4.666,4.666,0,0,1-4.8-3.92H238.12c.777-5.791-2.72-10.454-8.51-10.454a8.758,8.758,0,0,0-8.723,9.076,8.86,8.86,0,0,0,8.969,9.111m-32.03-.529h5.72L206.794,44.9h.14l3.108,10.912H215.8l4.839-17.126H215.9l-3.073,12.007h-.178l-3.5-12.007h-4.591l-3.5,11.936h-.14l-3.038-11.936h-4.909l4.839,17.126Zm-13.7.529c5.367,0,8.864-3.566,8.864-7.945s-2.72-6.534-6.993-7.451l-2.084-.458c-2.119-.458-3.672-1.342-3.672-2.9s1.272-2.79,3.426-2.79a4.434,4.434,0,0,1,4.485,3.885l.07.035a6.991,6.991,0,0,1,4.343-1.518l.07-.07c-.884-4.025-4.273-6.569-8.828-6.569-4.839,0-8.405,3.284-8.405,7.381,0,3.814,2.577,6.144,7.063,7.063l2.119.458c2.332.529,3.6,1.342,3.6,3.143s-1.413,3.248-3.885,3.248a5.181,5.181,0,0,1-5.4-4.766l-.105-.035a8,8,0,0,1-4.415,2.049l-.035.07c.919,4.661,4.979,7.168,9.783,7.168",
    transform: "translate(-138.336 -24.249)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M64.39,0V21.064A10.532,10.532,0,1,0,64.39,0Z",
    transform: "translate(-51.093)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M0,76.232A10.555,10.555,0,0,0,10.553,86.785V65.719A10.473,10.473,0,0,0,0,76.113Z",
    transform: "translate(0 -52.147)",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.549,
    cy: 4.549,
    r: 4.549,
    transform: "translate(13.299 25.537)",
    fill: "#171717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb3d21fd297132d8392ebf41be9534fd.svg";
export { ForwardRef as ReactComponent };